import { FC } from 'react'
import { Box, Typography } from '@material-ui/core'
import { BackendUser, JobProps, JobStatus } from 'common/types'
import { CustomIconContextMenu } from 'components/core/actions-menu-noborder/CustomIconContextMenu'
import JobApplyModal from 'components/core/modal/JobApplyModal/JobApplyModal'
import moment from 'moment'
import { StyledCopyIcon } from 'pages/content/components/posts/PostCard'
import { ReactComponent as ActionContextIcon } from 'icons/action-context-icon.svg'
import {
  DescriptionText,
  EllipsisButton,
  MiniJobCardContainer,
  MiniJobCardFooter,
  MiniJobCardHeader,
  MiniJobCardMain,
  MiniJobCardText
} from './styles'

import { CompanyProfileImg } from 'pages/content/components/jobs/styled'
import handleLongText from 'common/utils/handleLongText'
import { useMiniJobCard } from '../hooks/useMiniJobCard'
import { JobDetailsPill } from 'pages/content/components/jobs/components/JobDetailsPill'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { Button } from 'common/atoms/Button/Button'
import { useJobSalaryPillFormat } from 'pages/content/components/jobs/hooks/useJobSalaryPillFormat'
import { slugify } from 'common/utils/slugify'
import { createJobSlug } from 'common/utils/createJobSlug'

interface JobProp {
  job: JobProps
  user: BackendUser
  theme: any

  selected?: boolean
  handleClick?: (job: string) => void
}

const MiniJobCard: FC<JobProp> = ({ job, user, selected, theme, handleClick }) => {
  const { history, handleCopyClipBoard } = useMiniJobCard(job)
  const { isDevice } = useScreenSizes()

  const intl = Intl.NumberFormat('en-US')

  const pills = [
    job?.location
      ?.split(',')
      .filter(locationSegment => !!locationSegment?.trim())
      .join(','),
    job?.workplace,
    job?.jobType
  ].filter(val => !!val)

  const { formatSalary } = useJobSalaryPillFormat(job)

  const jobSlug = `/job/${createJobSlug(job?.id, job?.title)}`

  return (
    <MiniJobCardContainer
      id={`job-${job?.id}`}
      onClick={() => {
        handleClick(job?.id)
      }}
      minWidth={0}
      padding="0.8125rem 0.6875rem"
      border={`1px solid ${selected ? theme.colors.primary : theme.colors.supplementary1}`}
      bgcolor={selected ? theme.colors.bgPrimary : theme.colors.supplementary}
    >
      <a
        href={jobSlug}
        onClick={evt => {
          evt.preventDefault()
        }}
      >
        <Box>
          <MiniJobCardHeader minWidth="0" mb="1.25rem">
            <Box display={'flex'} width="100%" gridGap={12} overflow="hidden">
              <CompanyProfileImg
                isDevice={isDevice}
                src={job.companyLogo}
                onClick={() => history.push(`/company/${job?.partnerId}`)}
              />
              <Box width="80%" minWidth="0">
                <MiniJobCardText variant="subtitle1">
                  {job?.title}
                </MiniJobCardText>
                <MiniJobCardText variant="body1">{job?.companyName}</MiniJobCardText>
                <MiniJobCardText variant="caption" noWrap>
                  {moment(job?.createdAt).fromNow()}
                </MiniJobCardText>
              </Box>
            </Box>
            <Box>
              <EllipsisButton>
                <CustomIconContextMenu
                  anchorOriginHorizontal={'right'}
                  noPadding={true}
                  customItemPadding={'0rem 1.125rem'}
                  title=""
                  icon={<ActionContextIcon fill={theme?.colors?.accent} />}
                >
                  <Box onClick={handleCopyClipBoard}>
                    <StyledCopyIcon />
                    <span style={{ marginLeft: 8 }}>Copy Link</span>
                  </Box>
                </CustomIconContextMenu>
              </EllipsisButton>
            </Box>
          </MiniJobCardHeader>
        </Box>

        <Box display={'flex'} flexWrap="wrap" gridGap={'0.34rem'} justifyContent="start" maxWidth={'100%'}>
          {pills.map(pill => {
            return <JobDetailsPill height="unset" justifyContent="center" job={job} text={pill} />
          })}
          {formatSalary != '' && <JobDetailsPill justifyContent="center" job={job} text={formatSalary} />}
        </Box>
        {isDevice && (
          <Box width="100%" display="flex" justifyContent="flex-end" mt="0.875rem">
            <Button
              design="primary"
              onClick={() => {
                history.push(`/job/${createJobSlug(job?.id, job?.title)}`)
              }}
            >
              View Job
            </Button>
          </Box>
        )}
      </a>
    </MiniJobCardContainer>
  )
}

export default MiniJobCard
